import { HeroLayout, Index } from 'theme';
import * as React from 'react';
export default {
  HeroLayout,
  Index,
  React
};